module.exports = __webpack_public_path__ + "img/Frame_StageFrame_n_Blue.0e84debd.png";